const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnSettingXs(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.29 48.942v-2a.425.425 0 0 0-.425-.425h-1.149a.429.429 0 0 1-.412-.326 6.791 6.791 0 0 0-.715-1.712.429.429 0 0 1 .06-.524l.817-.816a.425.425 0 0 0 0-.6l-1.412-1.412a.425.425 0 0 0-.6 0l-.828.828a.429.429 0 0 1-.521.062 6.791 6.791 0 0 0-1.7-.7.429.429 0 0 1-.328-.413v-1.173a.425.425 0 0 0-.425-.425h-2a.425.425 0 0 0-.425.425v1.2a.428.428 0 0 1-.324.412 6.807 6.807 0 0 0-1.674.7.43.43 0 0 1-.524-.06l-.857-.857a.425.425 0 0 0-.6 0l-1.412 1.412a.425.425 0 0 0 0 .6l.866.866a.429.429 0 0 1 .062.521 6.787 6.787 0 0 0-.688 1.665.429.429 0 0 1-.412.326h-1.227a.424.424 0 0 0-.425.425v2a.424.424 0 0 0 .425.425h1.224a.429.429 0 0 1 .413.326 6.788 6.788 0 0 0 .688 1.668.429.429 0 0 1-.062.521l-.863.863a.425.425 0 0 0 0 .6l1.412 1.413a.425.425 0 0 0 .6 0l.852-.852a.429.429 0 0 1 .524-.06 6.8 6.8 0 0 0 1.679.706.429.429 0 0 1 .324.412v1.194a.425.425 0 0 0 .425.425h2a.425.425 0 0 0 .425-.425v-1.172a.429.429 0 0 1 .328-.413 6.794 6.794 0 0 0 1.706-.7.429.429 0 0 1 .521.062l.823.823a.425.425 0 0 0 .6 0l1.412-1.413a.425.425 0 0 0 0-.6l-.814-.814a.429.429 0 0 1-.06-.523 6.79 6.79 0 0 0 .714-1.715.429.429 0 0 1 .412-.326h1.146a.425.425 0 0 0 .424-.424zm-8.6 2.261a3.255 3.255 0 1 1 3.255-3.255 3.255 3.255 0 0 1-3.254 3.252z",
    transform: "translate(-695.692 -35.904)",
    style: {
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      fill: "none"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnSettingXs);
export default __webpack_public_path__ + "static/media/btn-setting-xs.8cc0e1b096924c09c94d3c3af53fe4ea.svg";
export { ForwardRef as ReactComponent };